export const coreTextLocales = {
  en: {
    coreText: {
      fileDetail: {
        backToFiles: "Back to Files",
        owner: "Owner",
        version: "Version",
        aiClassification: "AI Classification",
        ocrConfidence: "OCR Confidence",
        tags: "Tags",
        piiDetected: "PII Detected!",
        piiQuarantined: "This document contains personally identifiable information and has been quarantined.",
        actions: "Actions",
        copyLink: "Copy Link"
      },
      filesList: {
        tags: "Tags"
      },
      fileUpload: {
        uploading: "Uploading..."
      },
      ocrResult: {
        saving: "Saving..."
      },
      entityDocuments: {
        title: "Linked documents",
        fileId: "File ID",
        fileIdPlaceholder: "Firestore files document ID",
        fileName: "File name",
        docType: "Document type",
        link: "Link",
        unlink: "Unlink",
        empty: "No documents linked.",
        type: "Type",
        file: "File",
        version: "Version",
        types: {
          supplier_contract: "Supplier contract",
          purchase_order_document: "Purchase order",
          commercial_invoice: "Commercial invoice",
          packing_list: "Packing list",
          certificate_of_origin: "Certificate of origin",
          quality_certificate: "Quality certificate",
          customs_declaration: "Customs declaration",
          bill_of_lading: "Bill of lading",
          cmr: "CMR consignment note",
          air_waybill: "Air waybill",
          other: "Other"
        }
      },
      statusHistory: {
        title: "Status history",
        empty: "No status changes recorded yet."
      },
      footer: {
        about: "About",
        blog: "Blog",
        legal: "Legal"
      },
      shell: {
        breadcrumb: "Breadcrumb",
        mainNavigation: "Main navigation"
      },
      invoice: {
        eInvoice: "E-Invoice",
        eArchive: "E-Archive"
      },
      goodsReceipt: {
        openPos: "Open POs:"
      },
      productDetail: {
        bomRevisions: "BOM / Revisions"
      },
      returnList: {
        restockWarehouse: "Warehouse (restock)"
      },
      approvalInbox: {
        subtitle: "Generic SCM approvals (PO, SO, and more)"
      },
      notificationEngine: {
        subtitle: "Inbox + event log (extends existing notifications)"
      },
      overseasWarehouse: {
        finishedGoods: "Finished Goods (overseas)"
      },
      manufacturingOrder: {
        currentLot: "Current lot:"
      },
      rfqList: {
        inviteSuppliers: "Invite suppliers (optional)"
      }
    }
  },
  tr: {
    coreText: {
      fileDetail: {
        backToFiles: "Dosyalara Dön",
        owner: "Sahip",
        version: "Sürüm",
        aiClassification: "Yapay Zekâ Sınıflandırması",
        ocrConfidence: "OCR Güven Oranı",
        tags: "Etiketler",
        piiDetected: "Kişisel Veri Tespit Edildi!",
        piiQuarantined: "Bu belge kişisel olarak tanımlanabilir bilgiler içeriyor ve karantinaya alındı.",
        actions: "İşlemler",
        copyLink: "Bağlantıyı Kopyala"
      },
      filesList: {
        tags: "Etiketler"
      },
      fileUpload: {
        uploading: "Yükleniyor..."
      },
      ocrResult: {
        saving: "Kaydediliyor..."
      },
      entityDocuments: {
        title: "Bağlı belgeler",
        fileId: "Dosya kimliği",
        fileIdPlaceholder: "Firestore dosya belge kimliği",
        fileName: "Dosya adı",
        docType: "Belge türü",
        link: "Bağla",
        unlink: "Bağlantıyı kaldır",
        empty: "Bağlı belge yok.",
        type: "Tür",
        file: "Dosya",
        version: "Sürüm",
        types: {
          supplier_contract: "Tedarikçi sözleşmesi",
          purchase_order_document: "Satın alma siparişi",
          commercial_invoice: "Ticari fatura",
          packing_list: "Çeki listesi",
          certificate_of_origin: "Menşe şahadetnamesi",
          quality_certificate: "Kalite sertifikası",
          customs_declaration: "Gümrük beyannamesi",
          bill_of_lading: "Konşimento",
          cmr: "CMR taşıma senedi",
          air_waybill: "Hava yolu konşimentosu",
          other: "Diğer"
        }
      },
      statusHistory: {
        title: "Durum geçmişi",
        empty: "Henüz kaydedilmiş durum değişikliği yok."
      },
      footer: {
        about: "Hakkında",
        blog: "Blog",
        legal: "Yasal"
      },
      shell: {
        breadcrumb: "Sayfa yolu",
        mainNavigation: "Ana gezinme"
      },
      invoice: {
        eInvoice: "E-Fatura",
        eArchive: "E-Arşiv"
      },
      goodsReceipt: {
        openPos: "Açık satın alma siparişleri:"
      },
      productDetail: {
        bomRevisions: "Ürün Ağacı / Revizyonlar"
      },
      returnList: {
        restockWarehouse: "Depo (stoğa iade)"
      },
      approvalInbox: {
        subtitle: "Genel tedarik zinciri onayları (satın alma, satış siparişleri ve daha fazlası)"
      },
      notificationEngine: {
        subtitle: "Gelen kutusu + olay günlüğü (mevcut bildirimleri genişletir)"
      },
      overseasWarehouse: {
        finishedGoods: "Mamul (yurt dışı)"
      },
      manufacturingOrder: {
        currentLot: "Mevcut lot:"
      },
      rfqList: {
        inviteSuppliers: "Tedarikçileri davet et (isteğe bağlı)"
      }
    }
  },
  ar: {
    coreText: {
      fileDetail: {
        backToFiles: "العودة إلى الملفات",
        owner: "المالك",
        version: "الإصدار",
        aiClassification: "تصنيف الذكاء الاصطناعي",
        ocrConfidence: "دقة التعرف الضوئي",
        tags: "الوسوم",
        piiDetected: "تم اكتشاف بيانات شخصية!",
        piiQuarantined: "يحتوي هذا المستند على معلومات تعريف شخصية وقد تم وضعه في الحجر.",
        actions: "الإجراءات",
        copyLink: "نسخ الرابط"
      },
      filesList: {
        tags: "الوسوم"
      },
      fileUpload: {
        uploading: "جارٍ الرفع..."
      },
      ocrResult: {
        saving: "جارٍ الحفظ..."
      },
      entityDocuments: {
        title: "المستندات المرتبطة",
        fileId: "معرّف الملف",
        fileIdPlaceholder: "معرّف مستند الملف في Firestore",
        fileName: "اسم الملف",
        docType: "نوع المستند",
        link: "ربط",
        unlink: "إلغاء الربط",
        empty: "لا توجد مستندات مرتبطة.",
        type: "النوع",
        file: "الملف",
        version: "الإصدار",
        types: {
          supplier_contract: "عقد المورّد",
          purchase_order_document: "أمر شراء",
          commercial_invoice: "فاتورة تجارية",
          packing_list: "قائمة التعبئة",
          certificate_of_origin: "شهادة المنشأ",
          quality_certificate: "شهادة الجودة",
          customs_declaration: "بيان جمركي",
          bill_of_lading: "بوليصة الشحن",
          cmr: "سند نقل CMR",
          air_waybill: "بوليصة الشحن الجوي",
          other: "أخرى"
        }
      },
      statusHistory: {
        title: "سجل الحالة",
        empty: "لم تُسجَّل أي تغييرات في الحالة بعد."
      },
      footer: {
        about: "حول",
        blog: "المدونة",
        legal: "الشؤون القانونية"
      },
      shell: {
        breadcrumb: "مسار التنقل",
        mainNavigation: "التنقل الرئيسي"
      },
      invoice: {
        eInvoice: "فاتورة إلكترونية",
        eArchive: "أرشيف إلكتروني"
      },
      goodsReceipt: {
        openPos: "أوامر الشراء المفتوحة:"
      },
      productDetail: {
        bomRevisions: "قائمة المواد / المراجعات"
      },
      returnList: {
        restockWarehouse: "المستودع (إعادة التخزين)"
      },
      approvalInbox: {
        subtitle: "موافقات عامة لسلسلة الإمداد (أوامر الشراء وأوامر البيع وغيرها)"
      },
      notificationEngine: {
        subtitle: "صندوق الوارد + سجل الأحداث (يوسّع الإشعارات الحالية)"
      },
      overseasWarehouse: {
        finishedGoods: "بضائع تامة الصنع (في الخارج)"
      },
      manufacturingOrder: {
        currentLot: "الدفعة الحالية:"
      },
      rfqList: {
        inviteSuppliers: "دعوة الموردين (اختياري)"
      }
    }
  }
};
